module.exports = __webpack_public_path__ + "static/img/Homepage.5b17c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage.png
// module id = y/L6
// module chunks = 51